import React from 'react'
import { graphql } from 'gatsby'
import EssentialInfos from '../../ui/essentialInfos'
import { Firm } from './mapper'

type FirmEssentialsProps = {
  firm: Firm
  color: string | null
}

const FirmEssentials: React.FC<FirmEssentialsProps> = ({ firm, color }) => {
  const officeLabel =
    firm.nbOffices && firm.nbOffices > 1 ? 'Bureaux' : 'Bureau'

  return (
    <div className="">
      {firm &&
        (color ? (
          <div
            className="container mx-auto min-h-content rounded-xl shadow-lg w-full
                flex flex-col gap-8 flex-wrap justify-center text-white p-8"
            style={{ backgroundColor: color }}
          >
            <div className="flex flex-row justify-center gap-8">
              {firm.totalClients && (
                <EssentialInfos info={firm.totalClients} label="Clients" />
              )}
              {firm.foundedYear && (
                <EssentialInfos info={firm.foundedYear} label="Création" />
              )}
            </div>
            <div className="flex flex-row justify-center gap-8">
              {firm.employeeAgeAverage && (
                <EssentialInfos
                  info={firm.employeeAgeAverage}
                  label="Âge moyen"
                />
              )}
              {firm.nbOffices && (
                <EssentialInfos info={firm.nbOffices} label={officeLabel} />
              )}
            </div>
          </div>
        ) : (
          <div
            className="container mx-auto min-h-content rounded-xl shadow-lg w-full
                flex flex-col gap-8 flex-wrap justify-center bg-primary text-white p-8"
          >
            <div className="flex flex-row justify-center gap-8">
              {firm.totalClients && (
                <EssentialInfos info={firm.totalClients} label="Clients" />
              )}
              {firm.foundedYear && (
                <EssentialInfos info={firm.foundedYear} label="Création" />
              )}
            </div>
            <div className="flex flex-row justify-center gap-8">
              {firm.employeeAgeAverage && (
                <EssentialInfos
                  info={firm.employeeAgeAverage}
                  label="Âge moyen"
                />
              )}
              {firm.nbOffices && (
                <EssentialInfos info={firm.nbOffices} label={officeLabel} />
              )}
            </div>
          </div>
        ))}
    </div>
  )
}

export default FirmEssentials

export const query = graphql`
  fragment FirmEssentials on STRAPI_ACCOUNTING_FIRM {
    createdAt
    offices {
      id
    }
    foundedYear
    totalClients
    employeeAgeAverage
  }
`
